import React from "react";
import {Navigate, useParams} from "react-router-dom";
import {loader} from "graphql.macro";
import StdQuery from "../../common/StdQuery";

const GetDeposit = loader("./graphql/GetDeposit.graphql");

export default () => {
    const {id} = useParams();
    return (
        <StdQuery query={GetDeposit} variables={{id}}>
            {(data) => {
                const orderItemId = data?.deposit?.orderItem?.id;
                if (!orderItemId) {
                    return <Navigate to="/404" replace />;
                }
                return <Navigate to={`/app/orderItem/${orderItemId}?index=1`} replace />;
            }}
        </StdQuery>
    );
};
